/**
 * Mixin para manejar el estado de loading en botones
 * Previene múltiples clics durante operaciones asíncronas
 */
export default {
  data() {
    return {
      loading: false
    }
  },
  methods: {
    /**
     * Inicia el estado de loading
     */
    startLoading() {
      this.loading = true
    },
    
    /**
     * Finaliza el estado de loading
     */
    stopLoading() {
      this.loading = false
    },
    
    /**
     * Ejecuta una función asíncrona con loading automático
     * @param {Function} asyncFunction - Función asíncrona a ejecutar
     * @param {Object} options - Opciones adicionales
     * @param {number} options.delay - Delay mínimo en milisegundos (por defecto 300ms)
     * @returns {Promise} Resultado de la función asíncrona
     */
    async executeWithLoading(asyncFunction, options = {}) {
      const { delay = 300 } = options
      
      try {
        this.startLoading()
        
        // Ejecutar la función y esperar el delay mínimo en paralelo
        const [result] = await Promise.all([
          asyncFunction(),
          new Promise(resolve => setTimeout(resolve, delay))
        ])
        
        return result
      } catch (error) {
        console.error('Error en executeWithLoading:', error)
        throw error
      } finally {
        this.stopLoading()
      }
    }
  }
}